<template>
  <div class="country-selector" :class="{ open, disabled, 'is-loading': isLoading }">
    <dropdown-select
      v-model="value"
      :multiple="true"
      :options="countries"
      :label-parser="literal"
      :groups="groups"
      :disabled="disabled || isLoading"
      @open="open = true"
      @close="open = false"
    />
  </div>
</template>

<script>
import isFlipped from '@/mixins/isFlipped'
import DropdownSelect from './DropdownSelect.vue'

export default {
  components: { DropdownSelect },
  mixins: [isFlipped],
  props: ['selection', 'countries', 'disabled', 'isLoading'],
  data() {
    return {
      open: false,
      groupSelection: false,
    }
  },
  computed: {
    value: {
      get() {
        return this.selection
      },
      set(val) {
        this.$emit('update', val)
      },
    },
    mainCubeId() {
      return this.$store.state.query.mainCubeId
    },
    dimension() {
      return this.$store.getters.mainCountryDimension
    },
    groups() {
      if (this.isFlipped && this.dimension.id !== 'PAR') {
        const rawDimension = this.$store.getters.mainNonIndicatorDimensions.find(
          d => d.type === 'country'
        )
        if (rawDimension.options.hasGroups) {
          const crawlLeafs = (children, acum = []) => {
            children.forEach(child => {
              if (!(child.children && child.children.length)) acum.push(child.id)
              else crawlLeafs(child.children, acum)
            })
            return acum
          }

          const options = rawDimension.options
            .filter(opt => opt.children && opt.children.length)
            .concat(
              rawDimension.options
                .reduce((acum, opt) => acum.concat(opt.children), [])
                .filter(d => d && d.children && d.children.length)
            )
          return Object.fromEntries(
            options.map(opt => [opt.labels[this.lng], crawlLeafs(opt.children)])
          )
        }

        return {}
      }

      return this.$store.state.external.countriesGroups || {}
    },
  },
  methods: {
    literal(selection) {
      const template = text => {
        const label = this.$lng(this.dimension.name[this.lng], this.dimension.id)
        text = this.$lng(text, this.dimension.id)
        return `<label>${label}:</label><span class="value">${text}</span>`
      }

      const label = this.$lng(this.dimension.name[this.lng])
      let text
      if (this.countries.length === 0) text = `No ${label}`
      else if (selection.length) text = `Selected (${selection.length})`
      else text = `All ${label}` // `All items`

      text = this.$lng(text)
      return template(text)
    },
  },
}
</script>

<style lang="stylus">
.country-selector {
  cursor: pointer;
  flex: 1 1 0%;
  position: relative;

  &.open {
    .mobile & {
      border-bottom-color: transparent;
    }
  }

&.is-loading::after {
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    z-index: 10
    background-color: transparent
    content: ""
    cursor: progress
  }

  .dropdown-option {
    &:not([data-depth='0']) {
      padding-left: vw(7.5px);
    }
  }

  .dropdown-select__label {
    align-items: center;
    display: flex;

    > label {
      margin-right: 0.5em;
      font-size: 0.85em;
      line-height: 1.25;

      .mobile & {
        margin-right: 0.1em;

        +m-breakpoint(landscape) {
          margin-right: 0.5em;
        }
      }
    }

    > .value {
      m-ellipsis(100%);
      margin-right: 0.5em;
      margin-top: 0.15em;
      font-size: 0.85em;
      line-height: 1.75;
    }

    .value-literal {
      margin: 0;
      margin-right: 1em;

      .mobile & {
        m-font-size(16, 20);

        +m-breakpoint(landscape) {
          font-size: 0.85em;
          line-height: 1.3;
        }
      }
    }
  }
}

.country-selector__label {
  display: none;
  m-font-size(16, 20);
  align-items: center;
  color: $black;
  cursor: pointer;
  display: flex;
  left: vw(15px);
  position: absolute;
  text-align: start;
  top: 50%;
  transform: translateY(-50%);
  width: 75%;
}

.country-selector__groups {
  background-color: white;
  font-size: 0.8em;
}

.country-selector__groups__head {
  color: $blue;
  margin: 0;
  padding: vw(10px) vw(40px) vw(10px) vw(20px);

  .mobile & {
    font-size: 0.83em;
    line-height: 1.3;
    padding: vh(20px) vw(10px) vh(20px) vw(20px);

    +m-breakpoint(landscape) {
      padding: vh(10px) vw(10px);
    }
  }

  > span {
    &:after {
      content: '+';
      margin-left: 0.5em;
    }
  }

  &.active {
    border-bottom: 0px solid $gray;

    > span {
      &:after {
        content: '-';
      }
    }
  }
}
</style>
